// extracted by mini-css-extract-plugin
export default {"loader":"spinner-module--loader--JwWQ2","load8":"spinner-module--load8--zI9N4"};